import { Form as AntdForm } from "@mimber/ui-web"
import { FormProvider, FieldValues } from "react-hook-form"
import type { FormComponentProps } from "./Form.types"

/**
 * Form component that integrates React Hook Form with Ant Design Form
 * Provides Ant Design styling and layout while using React Hook Form for state management
 */
export function Form<
  TFormData extends FieldValues = FieldValues,
  TTransformedData extends FieldValues = TFormData,
>({
  form,
  children,
  onSubmit,
  onInvalid,
  layout = "vertical",
  size = "middle",
  ...antdProps
}: FormComponentProps<TFormData, TTransformedData>) {
  return (
    <FormProvider {...form}>
      <AntdForm<TFormData>
        layout={layout}
        size={size}
        onFinish={() => form.handleSubmit(onSubmit, onInvalid)()}
        style={{ width: "100%" }}
        {...antdProps}
      >
        {children}
      </AntdForm>
    </FormProvider>
  )
}
